<div class="widget-org-wrap" [class.is-overridden]="isOverridden">
  <app-org-tree-select
    [nodes]="organizations"
    [selectedId]="displaySelectedId"
    [placeholder]="topHeaderOrgName"
    [hideNullOption]="true"
    [disabled]="disabled"
    (selectionChange)="onSelectionChange($event)">
  </app-org-tree-select>
</div>
